import { gql } from '@apollo/client';

export * from './appSuggestion.query.generated';

export const APP_SUGGESTION = gql`
  query appSuggestion($appName: String!) {
    appSuggestion(appName: $appName) {
      criticality
      description
      industry
      jurisdiction
      name
      softwareType
    }
  }
`;
